import * as React from 'react';
import { isEmpty, isNil } from 'lodash';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { getInfluencerLocationsPreview } from 'utils/influencers';
import { __t, applyTranslations } from 'utils/language';

import './creator-tile-locations.scss';

import type { CreatorTile, InfluencerProfile } from 'types';

applyTranslations(require('./creator-tile-locations.i18n.json'));

type Props = {
  influencer: CreatorTile | InfluencerProfile,
  tileSize?: 'expanded' | 'collapsed'
};

const msgKey = 'creator_tile_locations';

const CreatorTileLocations: React.FunctionComponent<Props> = (
  {
    influencer,
    tileSize = 'expanded'
  }: Props
) => {
  const locations = getInfluencerLocationsPreview(influencer.locations);
  const influencerId = influencer.id || '';

  if (isEmpty(locations) || isNil(influencerId)) {
    return null;
  }

  const locationObject = {
    list: locations.slice(0, 1),
    tooltip: locations.slice(1, 3)
  };

  return (
    <section
      className="creator-tile-locations"
      data-qa="creator-tile-locations"
    >
      <div
        className="creator-tile-locations__icon"
        title={__t('influencer_tile_locations.location_label')}
      >
        <SVGDynamicIcon
          name="drop-pin-custom-fg"
          width={16}
          height={16}
          customColor="grey"
        />
      </div>
      <div
        className="creator-tile-locations__label text-overflow-ellipsis"
        title={`${__t(`${msgKey}.labels.location`)}: ${locationObject.list[0]}`}
        data-qa="creator-tile-locations__label"
        data-hj-suppress
      >
        {locationObject.list[0]}
      </div>
      {
        tileSize === 'expanded' && !isEmpty(locationObject.tooltip) &&
        <Tooltip
          message={`${locationObject.tooltip.join('<br />')}`}
          width="auto-compact"
          data={{ qa: 'creator-tile-locations__tooltip-wrapper' }}
        >
          &nbsp;{`(+${locationObject.tooltip.length} ${__t(`${msgKey}.labels.more`)})`}
        </Tooltip>
      }
    </section>
  );
};

export default CreatorTileLocations;
